"use client";

import { SxProps, Theme } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import MainContainer from "parts/mainContainer";
import SectionTitle from "parts/sectionTitle";

interface Props {
  image: string;
  title?: string;
  SubTitle?: string;
  description?: string;
  logo?: string;
  button?: {
    text: string;
    icon?: React.ReactNode;
  };
  link?: string;
  sx?: SxProps<Theme>;
  logoSx?: SxProps<Theme>;
}

const InnerPageBanner: React.FC<Props> = ({
  image,
  title,
  logo,
  logoSx,
  button,
  sx,
  SubTitle,
  description,
  // ⬇️ accept link from props
  link,
}) => {
  const { palette } = useTheme();
  return (
    <Box pt={5}>
      <MainContainer bgColor="transparent" disablePadding>
        <Box
          sx={{
            backgroundImage: `
      linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
      url(${image})
    `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
            borderRadius: 3,
            py: 15,
            px: 10,
          }}
        >
          {/* right shape start */}

          <Box
            sx={{ ...sx }}
            className="tw:absolute tw:w-[200px] tw:h-[50px] tw:bg-white tw:right-0 tw:bottom-0 tw:rounded-tl-lg tw:flex tw:items-center tw:justify-center"
          >
            {/* ⬇️ Wrapped button in anchor tag if link is provided */}
            {/* {link ? (
              <Button
                component="a"
                href={link}
                variant="text"
                endIcon={button.icon || null}
              >
                {button.text}
              </Button>
            ) : (
              <Button variant="text" endIcon={button.icon || null}>
                {button.text}
              </Button>
            )} */}
          </Box>
          <Box
            className="tw:absolute tw:w-[20px] tw:h-[20px] tw:bg-transparent tw:right-0 tw:bottom-[50px] tw:rounded-full"
            sx={{ boxShadow: "5px 5px 2px #fff" }}
          />
          <Box
            className="tw:absolute tw:w-[20px] tw:h-[20px] tw:bg-transparent tw:right-[200px] tw:bottom-[0px] tw:rounded-full"
            sx={{ boxShadow: "5px 5px 2px #fff" }}
          />
          {/* right shape end */}
          <Box
            gap={3}
            className="tw:h-full tw:flex tw:flex-col tw:justify-center"
          >
            <Box
              sx={{
                backgroundImage: `url(${logo})   `,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "center",
                ...logoSx,
              }}
            />

            {title && (
              <SectionTitle
                title={title}
                sx={{
                  lineHeight: 1.1,
                  fontSize: {
                    xs: 36,
                    sm: 48,
                    md: 80,
                  },
                  fontWeight: 500,
                  color: "white",
                }}
              />
            )}
            <Box sx={{ color: palette.secondary.contrastText }}>
              <Typography sx={{ fontSize: 18, fontWeight: 200 }}>
                {SubTitle}
              </Typography>
              <Typography
                sx={{
                  maxWidth: 500,
                  fontSize: 32,
                  fontWeight: 600,
                }}
              >
                {description}
              </Typography>
            </Box>
          </Box>
        </Box>
      </MainContainer>
    </Box>
  );
};

export default InnerPageBanner;
